import { render } from "./UnresolvedThread.vue?vue&type=template&id=0bf55764"
import script from "./UnresolvedThread.vue?vue&type=script&lang=js"
export * from "./UnresolvedThread.vue?vue&type=script&lang=js"

import "./UnresolvedThread.vue?vue&type=style&index=0&id=0bf55764&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__